import { Component, OnInit } from '@angular/core';
import { BaseInputDirective } from '../base-input.directive';
import { FormInfoService } from '../../services/dynamic-forms/form-info.service';
import { DynamicFormsService } from '../../services/dynamic-forms/dynamic-forms.service';
import { ErrorService } from '../../services/form-utility/error.service';
import { DynamicFormLoadDirective } from '../../directives/dynamic-form-structural.directive';
import { Optional } from '@angular/core';

@Component({
  selector: 'app-currency-input',
  templateUrl: './currency-input.component.html',
  styleUrls: ['./currency-input.component.css'],
})
export class CurrencyInputComponent extends BaseInputDirective implements OnInit {
  valueFormatted: string;

  constructor(
    formInfoService: FormInfoService,
    dynamicFormsService: DynamicFormsService,
    errorService: ErrorService,
    @Optional()
    dynamicFormDirective: DynamicFormLoadDirective,
  ) {
    super(formInfoService, dynamicFormsService, errorService, dynamicFormDirective);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  onInputKeyDown(event) {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    }
  }

  formatCurrency(x) {
    const z = Number(x.formControl.value).toFixed(2);
    this.valueFormatted = z;
    x.formControl.value = z;
  }
}
